// extracted by mini-css-extract-plugin
export default {"cls1":"AiSummary-cls1___b4e236982d1513454c5","cls2":"AiSummary-cls2__eb885f243e9ab9161837 AiSummary-cls1___b4e236982d1513454c5"};